import type * as React from "react"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import { DateTime } from "luxon"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCalendarDays, faCaretDown } from "@fortawesome/pro-solid-svg-icons"
import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"

type DatePickerProps = {
    value: DateTime | null
    onChange: (date: DateTime | null) => void
    minDate?: DateTime
    maxDate?: DateTime
    disabled?: boolean
}

export function MeetingDatePicker({ value, onChange, minDate, maxDate, disabled = false }: DatePickerProps) {
    const { l10n } = useAppLocalization()

    return (
        <DatePicker
            value={value}
            onChange={onChange}
            disabled={disabled}
            format={l10n.getString("date-time-format-date")}
            minDate={minDate}
            maxDate={maxDate}
            slots={{
                openPickerIcon: () => <FontAwesomeIcon size="xs" color="#94A3B8" icon={faCaretDown} />,
            }}
            slotProps={{
                textField: {
                    variant: "outlined",
                    InputProps: {
                        startAdornment: <FontAwesomeIcon color="#94A3B8" icon={faCalendarDays} />,
                        sx: {
                            maxWidth: "11rem",
                            borderRadius: ".75rem",
                            "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#CBD5E1",
                            },
                            "& .MuiInputBase-input": {
                                padding: ".5rem 0 .5rem .5rem !important",
                            },
                        },
                    },
                },
            }}
        />
    )
}
